import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { PhoneOutlined } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';
import { IconWithText } from '@uplift/ui-v2';
import { useStyles } from './styles';
import { ContactName } from '@uplift/types';
import { useUserAvatarAssetsQuery, useUserContactsQuery, useUserDisplayNameQuery } from '@uplift/queries';


export type PsychiatristCardProps = {
  providerId: string;
};

export const PsychiatristCard: React.VFC<PsychiatristCardProps> = ({ providerId }) => {
  const l10n = useL10n();
  const { classes } = useStyles();
  const { data: userContacts } = useUserContactsQuery(providerId);
  const { data: displayName } = useUserDisplayNameQuery(providerId);
  const { data: avatarAssets } = useUserAvatarAssetsQuery(providerId, { suspense: true });
  const avatarAsset = avatarAssets?.avatarAsset;
  const workPhone = userContacts?.find(x => x.value && x.name === ContactName.work);

  return (
    <Card>
      <CardContent>
        <Grid container direction="column" spacing={3}>
          <Grid container size="grow" gap={0}>
            <Grid>
              <img
                src={avatarAsset.url}
                alt="psychiatrist avatar"
                className={classes.avatar}
              />
            </Grid>
            <Grid container direction="column" size="grow" gap={0}>
              <Grid>
                <Typography variant="body1">
                  {displayName?.fullWithAffixes}
                </Typography>
              </Grid>
              <Grid>
                <Typography variant="body2">
                  {l10n.clientProfile.psychiatry.provider.psychiatrist}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid container direction="column" spacing={1} size="grow">
            <Grid>
              {workPhone && (
                <IconWithText icon={<PhoneOutlined className={classes.lightPrimaryIcon} />}>
                  {workPhone.value} <Typography variant="body2" component="span"><em>{l10n.clientProfile.psychiatry.provider.work}</em></Typography>
                </IconWithText>
              )}
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
